<template>
  <div class="mmm-header-root" :class="{ 'mmm-header-root--desktop': !mobile }">
    <desktop-header v-if="!mobile"></desktop-header>
    <mobile-header v-if="mobile"></mobile-header>
  </div>
</template>

<script lang="ts" setup>
import { useStyleTag } from '@vueuse/core';
import { onBeforeMount, onMounted, ref } from 'vue';

import globals from './globals.scss?inline';
import { NavigationService } from './helper.ts';
import DesktopHeader from './partials/HeaderDesktop.ce.vue';
import MobileHeader from './partials/HeaderMobile.ce.vue';

// Append CSS to the global document head
useStyleTag(globals);

const mobile = ref<boolean>(false);

const breakpoint = 1200;

function handleResize() {
  mobile.value = window.innerWidth <= breakpoint;
}

onMounted(async () => {
  await NavigationService.whenReady();

  window.addEventListener('resize', handleResize, { passive: true });
  handleResize();
});

onBeforeMount(() => {
  window.removeEventListener('resize', handleResize);
});
</script>

<style lang="scss" scoped>
.mmm-header-root {
  --backdrop-color: rgba(0, 0, 0, 0.54);
  --header-desktop-height: auto;
  --header-background-variant: #f3f6f8; // current background color of layer 4. do we have something similar?
  --header-desktop-max-width: 1400px;
  --first-accent: #720035;
  --second-accent: #002055;
  --third-accent: #015213;
  --forth-accent: #262c2f;
  --overlay-background: var(--color-primary-lighter);
  --overlay-background-second-level: #fafcfe;
  --overlay-background-third-level: #fafcfe;
  --default-text-color: #262c2f;
  --sub-menu-item-active-background: #ffffff;
  --sub-menu-item-hover-background: #e0e5e8;
  --mobile-menu-color: #262c2f;
  --mobile-border-color: #e0e5e8;
  --current-accent: var(--color-accent);
  --sub-level-gap: 20px;
  --default-min-height: 548px;

  height: calc(var(--header-mobile-height) + var(--sub-header-mobile-height));

  position: relative;
  z-index: 10;

  &--desktop {
    height: var(--header-desktop-height);
  }
}
</style>
